import { render, staticRenderFns } from "./AppAvaliacaoLista.vue?vue&type=template&id=25b84c2c&"
import script from "./AppAvaliacaoLista.vue?vue&type=script&lang=js&"
export * from "./AppAvaliacaoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports